<template>
  <div class="flex-container">
    <el-breadcrumb class="flex-item" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="text-center" :to="{ path: '/sys/linXuanChannel/list' }"
      >门店审批</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form
        class="flex-item role-form"
        ref="validateForm"
        :model="form"
        size="mini"
        :rules="rules"
        :validate-on-rule-change="false"
        label-width="200px"
    >
      <el-row>
        <!--新增商户申报-->
        <div >
          <el-col :span="8">
            <el-form-item label="门店编号:" readonly prop="channelName">
              <el-input value="1234566"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="门店名称:" readonly prop="channelName">
              <el-input value="门店A"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属地区:" readonly prop="channelName1">
              <el-input value="海淀区"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="经营地址:" readonly prop="channelName1">
              <el-input value="北京市海淀区知春路"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="营业开始时间:" readonly prop="channelName1">
              <el-input value="09:00"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="营业结束时间:" readonly prop="channelName1">
              <el-input value="18:00"></el-input>
            </el-form-item>
          </el-col>
        </div>

        <!--<el-col :span="12">
          <el-form-item label="初审状态:" prop="technicalPerson">
            <el-input type="text" value="通过" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="初审意见:" prop="technicalPerson">
            <el-input type="text" value="同意" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="复审意见:" prop="technicalPerson">
            <el-input type="textarea" :rows="2" value="同意"></el-input>
          </el-form-item>
        </el-col>-->
      </el-row>
    </el-form>
    <div class="flex-item" style="text-align: center">
      <el-button size="mini" @click="back">返回</el-button>
      <!--<el-button size="mini" type="primary" @click="save">保存</el-button>-->
    </div>
  </div>
</template>

<script>
import {
  list
} from "@/api/system/linXuanChannel/linXuanChannel";

export default {
  name: "index",
  data() {
    return {
      userName:'',
      operator:'',
      declareType:'',
      isReadOnly:false,
    };
  },
  mounted() {
    this.operator=this.$route.params.operator;
    if(this.operator=='detail'){
      this.isReadOnly = true;
    }
    this.declareType=this.$route.params.declareType;
    this.userName=this.$store.state.token;
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    back() {
      this.$router.go(-1);
    },
    save() {
      this.$router.push({
        path: '/sys/channelDeclare/list'
      });
    },
    download(){
      this.$message('开发中');
    }
  },
};
</script>
<style scoped>
.el-card {
  height: 100%;
}
.btn_box {
  text-align: right;
  margin-top: 8px;
  height: 40px;
}
.flex-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
}
.flex-item:nth-child(1),
.flex-item:nth-child(3) {
  flex-grow: 0;
  flex-shrink: 0;
}
.flex-item:nth-child(2) {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}
.role-form {
  margin: 15px 0;
}
.el-form-item {
  margin-bottom: 7px;
}
.el-form-item__label {
  line-height: 1.0;
}
.el-form-item__content {
  line-height: 1.0;
}
/* 可选：调整标题栏布局，让按钮靠右 */
::v-deep .custom-accordion .el-accordion-item__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 去掉默认标题文字的多余样式 */
::v-deep .custom-accordion .el-accordion-item__header-text {
  display: none;
}
</style>